module.exports = __webpack_public_path__ + "media/images/sp/stores/shibuya/shibuya_concept_03-9cafb2ed1e494752c5d0bd02255a79a4.jpg";